<template>
  <div id="contenedor-main-listado">
    <template v-if="!$vuetify.breakpoint.mobile">
      <desktop desktop :reportesFisicos="getReportesFisicos" />
    </template>
    <template v-else>
      <mobile :reportesFisicos="getReportesFisicos" />
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListado',
  components: {
    Desktop,
    Mobile,
  },
  props: {
    reportesFisicos: Array,
  },
  data() {
    return {};
  },
  computed: {
    getReportesFisicos() {
      if (!this.reportesFisicos) return [];
      return this.reportesFisicos;
    },
  },
};
</script>

<style lang="scss">

</style>
